import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { Store, select } from '@ngrx/store';
import * as exportedDataActions from '../store/actions/exported-data.action';
import { OrdersServerService } from '../../orders/services/orders.service';
import * as exportedDataSelectors from '../store/selectors/exported-data.selector';
import { ToastrService } from 'ngx-toastr';
import * as authActions from '../../auth/store/actions/auth.action';


@Injectable()
export class ExportedDataEffects {
  constructor(
    private actions$: Actions, 
    private ordersService: OrdersServerService,
    private store: Store,
    private toastr: ToastrService
  ) {}

  exportOrders$ = createEffect(() =>
    this.actions$.pipe(
      ofType(exportedDataActions.exportOrders),
      withLatestFrom(this.store.pipe(select(exportedDataSelectors.selectFilters))),
      mergeMap(([action, filters]) => {
        // Asegúrate de que filters tenga 'from' y 'to' como Date
        const from = typeof filters.from === 'string' ? new Date(filters.from) : filters.from;
        const to = typeof filters.to === 'string' ? new Date(filters.to) : filters.to;
        return this.ordersService.getExportedData(from, to).pipe(
          map(response => exportedDataActions.exportOrdersSuccess({ data: response })),
          catchError(error => {
            if (error.status === 401) {
              this.toastr.error('Usuario no autenticado');
              return of(authActions.logout());
            }
            this.toastr.error('No se pudo exportar el reporte');
            return of(exportedDataActions.exportOrdersFailure({ error }));
          })
        );
      })
    )
  );
}